// TODO usages of this should be replaced with Queries.ButtonStyle
export enum ButtonStyle {
  TRANSPARENT = 'transparent',
  SECONDARY_TRANSPARENT = 'secondary_transparent',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  ALERT = 'alert',
}

export enum RedesignButtonStyle {
  PLUM = 'plum',
  DARK_GREEN = 'dark_green',
  TRANSPARENT_WITH_PLUM_FONT = 'transparent',
  TRANSPARENT_WITH_WHITE_FONT = 'transparent_with_white_font',
  WHITE_WITH_PLUM_FONT = 'white_with_plum_font',
  WHITE_WITH_GREEN_FONT = 'white_with_green_font',
}

export enum RedesignMeridianButtonStyle {
  ORANGE = 'orange',
  BLUE = 'blue',
  TRANSPARENT_WITH_WHITE_FONT_AND_BORDER = 'transparent_with_white_font_and_border',
  TRANSPARENT_WITH_BLUE_FONT_AND_BORDER = 'transparent_with_blue_font_and_border',
  WITHOUT_BORDERS_WITH_WHITE_FONT = 'without_borders_with_white_font',
  WITHOUT_BORDERS_WITH_BLUE_FONT = 'without_borders_with_blue_font',
}

export enum RedesignHarbourButtonStyle {
  HARBOUR_GREY_WITH_WHITE_FONT = 'harbour_grey_with_white_font',
  TRANSPARENT_WITH_GREY_FONT_AND_BORDER = 'transparent_with_grey_font_and_border',
  TRANSPARENT_WITH_GOLD_FONT_AND_BORDER = 'transparent_with_gold_font_and_border',
  WHITE_WITH_HARBOUR_GREY_FONT = 'white_with_harbour_grey_font',
}

export enum ButtonsArrangement {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export enum OverlayColor {
  PLUM = 'plum',
  DARK_GREEN = 'dark_green',
}
